import script from "./task-report.vue?vue&type=script&setup=true&lang=js"
export * from "./task-report.vue?vue&type=script&setup=true&lang=js"

import "./task-report.vue?vue&type=style&index=0&id=57519a14&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57519a14"]])

export default __exports__